import { Component, HostBinding } from "@angular/core";

@Component({
  selector: 'th[resizable]',
  templateUrl: './resizable-table.component.html',
  styleUrls: ['./resizable-table.component.scss'],
})
export class ResizableComponent {
  @HostBinding('style.width.px')
  width: number | null = null;

  onResize(width: number) {
    this.width = width;
  }
}


